
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-miterlimit":"10","stroke-width":"2","d":"M29.502 46.078c-.37 0-.66.29-.68.63l-.26 6.99c-.03.39.29.71.66.71h1.94c.37 0 .68-.32.66-.71l-.29-6.96c0-.37-.32-.63-.68-.63l-1.34-.03h-.01zm1.13-27.49c.89-.95 2.89-3.36 2.89-6.2 0-2.84-2-5.25-2.89-6.2a.622.622 0 00-.89 0c-.89.95-2.89 3.36-2.89 6.2 0 2.84 2 5.25 2.89 6.2.24.24.66.24.89 0zm1.89-.11c-1.79 2.21-1.76 5.33-1.65 6.64.03.34.34.6.66.55 1.31-.16 4.36-.79 6.14-2.99 1.79-2.21 1.76-5.33 1.65-6.64-.03-.34-.34-.6-.66-.55-1.29.18-4.36.79-6.14 2.99zm-3.02 6.65c.11-1.31.13-4.44-1.65-6.64-1.79-2.21-4.86-2.81-6.14-2.99-.34-.03-.66.18-.66.55-.11 1.31-.13 4.44 1.65 6.64 1.79 2.21 4.86 2.81 6.14 2.99.32.05.63-.21.66-.55zm3.02 3.02c-1.79 2.21-1.76 5.33-1.65 6.64.03.34.34.6.66.55 1.31-.16 4.36-.79 6.14-2.99 1.78-2.2 1.76-5.33 1.65-6.64-.03-.34-.34-.6-.66-.55-1.29.18-4.36.79-6.14 2.99zm-3.02 6.64c.11-1.31.13-4.44-1.65-6.64-1.79-2.21-4.86-2.81-6.14-2.99-.34-.03-.66.18-.66.55-.11 1.31-.13 4.44 1.65 6.64 1.79 2.21 4.86 2.81 6.14 2.99a.6.6 0 00.66-.55zm3.02 2.97c-1.79 2.21-1.76 5.33-1.65 6.64.03.34.34.6.66.55 1.31-.16 4.36-.79 6.14-2.99 1.79-2.21 1.76-5.33 1.65-6.64-.03-.34-.34-.6-.66-.55-1.29.18-4.36.79-6.14 2.99zm-4.68 0c-1.79-2.21-4.86-2.81-6.14-2.99-.34-.03-.66.18-.66.55-.11 1.31-.13 4.44 1.65 6.64 1.79 2.21 4.86 2.81 6.14 2.99.34.03.66-.18.66-.55.11-1.31.13-4.44-1.65-6.64z"}})])
          )
        }
      }
    